import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
  // base: process.env.BASE_URL,
  // base: "/make-online/",
  mode: 'history',
  routes: [
    {
      path: "/maker",
      name: "maker",
      component: () => import("../views/maker.vue"),
      meta: { requiresAuth: true }
    }, {
      path: "/maker2",
      name: "maker2",
      component: () => import("../views/maker2.vue"),
      meta: { requiresAuth: true }
    }, {
      path: "/process",
      name: "process",
      component: () => import("../views/process.vue")
    }, {
      path: "/order-preview",
      name: "order-preview",
      component: () => import("../views/order-preview.vue")
    }
  ]
});
